// ts-gql-integrity:115ef77e12c4498d499b7e39b1cfe2ae
/*
ts-gql-meta-begin
{
  "hash": "bf763d12649ff0606d65bb951d472344"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type entityTypesQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


type entityTypesQuery = { readonly __typename: 'Query', readonly entityTypes: ReadonlyArray<{ readonly __typename: 'EntityType', readonly id: string, readonly name: string, readonly type: SchemaTypes.EntityTypeType, readonly selectable: boolean }> };



export type type = TypedDocumentNode<{
  type: "query";
  result: entityTypesQuery;
  variables: {};
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    entityTypes: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"entityTypes\"},\"variableDefinitions\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"entityTypes\"},\"arguments\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"selectable\"},\"arguments\":[],\"directives\":[]}]}}]}}]}")
